// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { MintingClaimAttributeValue } from '../models/MintingClaimAttributeValue';
import { HttpFile } from '../http/http';

export class MintingClaimAttribute {
    'trait_type': string;
    'value': MintingClaimAttributeValue;
    'display_type'?: string;
    'max_value'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "trait_type",
            "baseName": "trait_type",
            "type": "string",
            "format": ""
        },
        {
            "name": "value",
            "baseName": "value",
            "type": "MintingClaimAttributeValue",
            "format": ""
        },
        {
            "name": "display_type",
            "baseName": "display_type",
            "type": "string",
            "format": ""
        },
        {
            "name": "max_value",
            "baseName": "max_value",
            "type": "number",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return MintingClaimAttribute.attributeTypeMap;
    }

    public constructor() {
    }
}
